// removed by extract-text-webpack-plugin
module.exports = {"top-hot-line":"top-hot-line","hot-line-content":"hot-line-content","content-red":"content-red"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_HotLine.scss
// module id = ./components/layouts/master/sub-header/_HotLine.scss
// module chunks = 0